export const RECTANGLE_STATUS_COLOR = {
    LARANJA: '#f5a623',
    VERDE: '#48d53a',
    AZUL: '#2382f5'
};
